module.exports = __webpack_public_path__ + "static/media/flecheLiOrange.9f023b55.svg";